import React from 'react';

import Typography from 'components/ui/Typography/Typography';

interface Props {
    message: string;
}

const AlertBox: React.FC<Props> = ({ message }) => {
    return (
        <Typography
            color="red"
            align="center"
            className="p-4 w-full border-2 bg-red-100 border-white rounded-xl"
            style="BodyMedSemibold"
        >
            {message}
        </Typography>
    );
};

export default AlertBox;
